import React from 'react';
import PropTypes from 'prop-types';
import './Popup.css';

function PopupContent({ className, children }) {
  return (
    <div className={`flexColumn popupv2-content ${className}`}>
      { React.Children.map(children, child => (React.isValidElement(child)) && React.cloneElement(child)) }
    </div>
  )
}

PopupContent.propTypes = {
  className: PropTypes.string
}

export default PopupContent;
